import React from 'react'
import { FlatListProps as RNFlatListProps, FlatList as RNFlatlist } from 'react-native'

import { Box } from 'widgets/Box'
import { LoadingSpinner } from 'widgets/LoadingSpinner'
import { NoContent } from 'widgets/NoContent'
import { Text } from 'widgets/Text'

import { getTextColorFromBackgroundColor } from 'utils/theme'
import { ThemeColor } from 'utils/themes/types'

export interface FlatListProps<T> extends RNFlatListProps<T> {
  loading?: boolean
  ListHeaderComponent?: React.ReactElement
  noContentProps?: {
    message?: string
    icon?: string
    marginTop?: number
    marginBottom?: number
  }
  onEndReached?: () => void
  backgroundColor?: ThemeColor
  textColor?: ThemeColor
  isSearching?: boolean
  onRowSelect?: () => void
  useRNEmptyComponent?: boolean
}

export const FlatList = <T,>({
  loading = false,
  ListHeaderComponent,
  noContentProps = {},
  data,
  backgroundColor,
  textColor,
  useRNEmptyComponent = false,
  ...props
}: FlatListProps<T>) => {
  let content
  let messageTextColor = textColor

  if (!messageTextColor && backgroundColor) {
    messageTextColor = getTextColorFromBackgroundColor(backgroundColor)
  }

  if (loading) {
    content = (
      <Box
        display='flex'
        flex={1}
        justifyContent='center'
        align='center'
        height='100%'
        backgroundColor={backgroundColor}
      >
        <LoadingSpinner />
        <Box padding={{ vertical: 'sm' }}>
          <Text color={messageTextColor}>Loading...</Text>
        </Box>
      </Box>
    )
  } else if (!loading && (!data || !data.length) && useRNEmptyComponent) {
    content = (
      <RNFlatlist
        data={data}
        ListHeaderComponent={ListHeaderComponent}
        ListEmptyComponent={
          <NoContent textColor={messageTextColor} marginTop={64} {...noContentProps} />
        }
        {...props}
      />
    )
  } else if (!loading && (!data || !data.length) && !useRNEmptyComponent) {
    content = (
      <>
        {ListHeaderComponent}
        <NoContent textColor={messageTextColor} {...noContentProps} />
      </>
    )
  } else {
    content = <RNFlatlist data={data} ListHeaderComponent={ListHeaderComponent} {...props} />
  }

  return (
    <Box height='100%' backgroundColor={backgroundColor}>
      {content}
    </Box>
  )
}
